import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TagOutline } from '@bonusly/design-system';

import { useActionInput } from '../../context';
import { useIsEnabled } from '../../hooks/use-is-enabled';
import { insertTrigger } from '../../lib/insert-trigger';
import { DecorationButton } from './decoration-button';

interface MentionButtonProps {
	decorationVariant?: 'default' | 'list-item';
}

export const MentionButton: FC<MentionButtonProps> = ({ decorationVariant = 'default' }) => {
	const isEnabled = useIsEnabled('mention');
	const { editor } = useActionInput();
	const { t } = useTranslation('action_input');

	if (!isEnabled) {
		return null;
	}

	const handleClick = () => {
		if (editor) {
			insertTrigger(editor, '&');
		}
	};

	return (
		<DecorationButton
			label={decorationVariant === 'list-item' ? t('decorations.tag_tooltip_short') : t('decorations.tag_tooltip')}
			onClick={handleClick}
			decorationVariant={decorationVariant}
		>
			<TagOutline />
		</DecorationButton>
	);
};
